export default "__VITE_ASSET__7nFWdklh__"